var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form"
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Formação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.formacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "formacao", $$v);
      },
      expression: "form.filters.formacao"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 3,
      "label": "Data de Realização",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataRealizacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataRealizacao", $$v);
      },
      expression: "form.filters.dataRealizacao"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Origem",
      "outlined": "",
      "dense": "",
      "items": _vm.form.lists.origens,
      "item-text": "nome",
      "item-value": "id"
    },
    model: {
      value: _vm.form.filters.origemId,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "origemId", $$v);
      },
      expression: "form.filters.origemId"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Situação",
      "outlined": "",
      "dense": "",
      "items": _vm.opcoesStatus,
      "item-text": "descricao",
      "item-value": "value",
      "id": "situacao",
      "hide-details": "auto"
    },
    model: {
      value: _vm.form.filters.situacao,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "situacao", $$v);
      },
      expression: "form.filters.situacao"
    }
  })], 1), _c('sigfoco-date-picker', {
    ref: "dataInicioPicker",
    attrs: {
      "label": "Início do Período",
      "cols": 2,
      "removeIcon": "",
      "dataEdicao": _vm.form.filters.dataInicio
    },
    model: {
      value: _vm.form.filters.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicio", $$v);
      },
      expression: "form.filters.dataInicio"
    }
  }), _c('sigfoco-date-picker', {
    ref: "dataFimPicker",
    attrs: {
      "label": "Fim do Período",
      "cols": 2,
      "removeIcon": "",
      "dataEdicao": _vm.form.filters.dataFim
    },
    model: {
      value: _vm.form.filters.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFim", $$v);
      },
      expression: "form.filters.dataFim"
    }
  })], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-tooltip', {
    attrs: {
      "text": "Buscar",
      "icon": "mdi-magnify"
    },
    on: {
      "click": function ($event) {
        return _vm.buscarHistoricoFormacao();
      }
    }
  }), _c('sigfoco-tooltip', {
    attrs: {
      "text": "Limpar",
      "icon": "mdi-eraser"
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.dataRealizacao`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$formatarData(item.dataRealizacao)) + " ")];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar",
            "icon": "mdi-eye-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarHistoricoFormacao(item);
            }
          }
        }), item.avaliacaoId != null && item.situacao == 'Presente' ? _c('sigfoco-tooltip', {
          attrs: {
            "text": "Avaliar Formação",
            "icon": "mdi-plus-box-multiple-outline",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogCadastrarHistoricoFormacao(item);
            }
          }
        }) : _vm._e()];
      }
    }], null, true)
  })], 1), _vm.dialogVisualizarHistoricoFormacao.visible ? _c('VisualizarHistoricoFormacaoDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarHistoricoFormacao.visible,
      "content": _vm.dialogVisualizarHistoricoFormacao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogVisualizarHistoricoFormacao.close();
      }
    }
  }) : _vm._e(), _vm.dialogCadastrarHistoricoFormacao.visible ? _c('CadastrarAvaliacaoFormacaoDialog', {
    attrs: {
      "visible": _vm.dialogCadastrarHistoricoFormacao.visible,
      "content": _vm.dialogCadastrarHistoricoFormacao.content
    },
    on: {
      "onClose": function ($event) {
        return _vm.dialogCadastrarHistoricoFormacao.close();
      }
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }